import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { getBankDeposit, insertBankDeposit, updateBankDeposit } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { initializeBankDepositForm } from 'actions/FormActions';
import LOOKUP from 'constants/lookup';
import { selectBankDepositModel } from 'selectors/entitySelector';
import util from 'library/util';
import { bankDepositsEditCrumb, bankDepositsAddCrumb } from 'utils/breadcrumbInfo';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import CardSimple from 'screens/components/basic/CardSimple';
import DecimalInput from 'screens/components/basic/DecimalInput';
import Grid from 'screens/components/basic/Grid';
import PageHeader from 'screens/components/basic/PageHeader';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';

class BankDepositSave extends Component {
  constructor(props) {
    super(props);

    this.state = {
      operation: ""
    };
  }

  componentWillMount() {
    const bankDepositId = this.props.params ? this.props.params.id : null;
    if (bankDepositId) {
      this.setState({ operation: "EDIT" });
      this.props.getBankDeposit(bankDepositId);
    }
    else {
      this.setState({ operation: "ADD" });
      this.props.init(this.props.name);
    }
  }

  componentWillReceiveProps(newProps) {
    if ((newProps.saveSuccess != null && newProps.saveSuccess !== this.props.saveSuccess)
      || (newProps.saveError != null && newProps.saveError !== this.props.saveError)) {

      if (newProps.saveSuccess) this.saveSuccess();
      else if (newProps.saveError) this.saveError();
    }
  }

  saveSuccess = () => {
    this.props.callListView();
    this.props.showBankDepositSuccess(this.state.operation === "EDIT" ?
      LOOKUP.bankdeposits.messages.editedMessage : LOOKUP.bankdeposits.messages.createdMessage);
  }

  saveError = () => {
    this.props.showBankDepositError(LOOKUP.bankdeposits.messages.saveErrorMessage);
  }

  saveBankDeposit = () => {
    const p = this.props;
    let deposit = p.bankDepositModel;

    // this validation does not show as red in the usual form validator.
    if (!moment(deposit.depositDate).isSameOrBefore(moment(), 'day')) {
      this.props.showSnackbar("Date cannot be in the future");
      return;
    }

    const validators = [
      [p.name + 'Amount', deposit => (deposit.amount >= 0), "Amount"]
    ];

    if (util.validate(validators, deposit, this.props.formError)) {
      if (this.state.operation === "ADD")
        this.props.insertBankDeposit(deposit);
      else
        this.props.updateBankDeposit(deposit);
    }
  };

  cancelBankDeposit = () => {
    this.props.callListView();
  };

  render() {
    const p = this.props;
    const breadCrumbPage = this.state.operation === 'EDIT' ? bankDepositsEditCrumb : bankDepositsAddCrumb

    return (
      <Grid headerContent={breadCrumbPage}>
        <PageHeader title={LOOKUP.bankdeposits.title} />
        <CardSimple className="p-1">
          {(this.state.operation === 'EDIT') ?
            <div className="row">
              <div className="col-lg-8">
                <TextInput name={p.name + "Id"}
                  label={LOOKUP.bankdeposits.fields.id.label}
                  floatingLabelText={LOOKUP.bankdeposits.fields.id.label}
                  hintText={LOOKUP.bankdeposits.fields.id.hint}
                  disabled={true}
                  fullWidth={true} />
              </div>
            </div>
            : null
          }
          <div className="row">
            <div className="col-lg-12">
              <DatePickerInput name={`${p.name}DepositDate`} floatingLabelText={LOOKUP.bankdeposits.fields.depositDate.label} fullWidth={true} hintText={LOOKUP.bankdeposits.fields.depositDate.hint} />
            </div>
            <div className="col-lg-12">
              <DecimalInput name={`${p.name}Amount`} floatingLabelText={LOOKUP.bankdeposits.fields.amount.label} fullWidth={true} hintText={LOOKUP.bankdeposits.fields.amount.hint} />
            </div>
            <div className="col-lg-12">
              <DecimalInput name={`${p.name}CoinOrder`} floatingLabelText={LOOKUP.bankdeposits.fields.coinOrder.label} fullWidth={true} hintText={LOOKUP.bankdeposits.fields.coinOrder.hint} />
            </div> 
            {!p.isHighTide  && (
            <div className="col-lg-12">
              <DecimalInput name={`${p.name}Tips`} floatingLabelText={LOOKUP.bankdeposits.fields.tips.label} fullWidth={true} hintText={LOOKUP.bankdeposits.fields.tips.hint} />
            </div>
            )}    
            <div className="col-lg-12">
              <TextInput name={`${p.name}ReferenceCode`} floatingLabelText={LOOKUP.bankdeposits.fields.referenceCode.label} fullWidth={true} hintText={LOOKUP.bankdeposits.fields.referenceCode.hint} />
            </div>
            <div className="col-lg-12">
              <TextInput name={`${p.name}Notes`} floatingLabelText={LOOKUP.bankdeposits.fields.notes.label} fullWidth={true} hintText={LOOKUP.bankdeposits.fields.notes.hint} />
            </div>
            {/* <div className="col-lg-12">
              <TextInput name={`${p.name}User`} floatingLabelText={LOOKUP.bankdeposits.fields.userName.label} fullWidth={true} hintText={LOOKUP.bankdeposits.fields.userName.hint} disabled />
            </div> */}
          </div>
        </CardSimple>
        <PageBottomWithButtons>
          <Button name="buttonSave"
            className="pull-right btnNewBrandPOS"
            label={LOOKUP.bankdeposits.controls.saveButton}
            primary={true}
            onTouchTap={() => this.saveBankDeposit()} />
          <Button name="cancelButton"
            className="pull-right btn-space btnCleanSearch"
            label={LOOKUP.bankdeposits.controls.cancelButton}
            onTouchTap={() => this.cancelBankDeposit()} />
        </PageBottomWithButtons>
      </Grid>
    );
  }
}

function mapStatetoProps(state, props) {
  const appSettings = state.common && state.common.applicationSettings ? state.common.applicationSettings : {};
  return {
    bankDepositModel: selectBankDepositModel(state, props.name),
    saveSuccess: state.form[props.name + "SaveSuccess"],
    saveError: state.form[props.name + "SaveError"],
    isHighTide: appSettings.isHighTide || false
  };
}

function mapDispatchToProps(dispatch, props) {
  return {
    init: (name) => dispatch(initializeBankDepositForm(name)),
    insertBankDeposit: (model) => dispatch(insertBankDeposit({ model, compName: props.name })),
    updateBankDeposit: (model) => dispatch(updateBankDeposit({ model, compName: props.name })),
    showBankDepositSuccess: (message) => dispatch(showSnackbar(message)),
    getBankDeposit: (id) => dispatch(getBankDeposit({ id, compName: props.name })),
    showBankDepositError: (message) => dispatch(showError(message)),
    showSnackbar: (message) => dispatch(showSnackbar(message)),
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error })
  };
}

export default connect(mapStatetoProps, mapDispatchToProps)(BankDepositSave);
